import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/Pan330AC.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Panasonic 330W AC Panel" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/Pan330AC.js